/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const DefaultCourseTeacherRoleSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('DEFAULT_COURSE_TEACHER_ROLE')],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ parsers.exactly('Full Teacher', 'Non-Editing Teacher')),
    ],
]);
export class DefaultCourseTeacherRoleSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return DefaultCourseTeacherRoleSettingParser.decode(input).map(res => new DefaultCourseTeacherRoleSetting(res));
    }
    static unsafeDecode(input) {
        return DefaultCourseTeacherRoleSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return DefaultCourseTeacherRoleSettingParser.encode(data);
    }
    static schema() {
        return DefaultCourseTeacherRoleSettingParser.schema();
    }
}
